// Signature config routes
export default [
  {
    path: 'signature',
    name: 'signatureConfig',
    component: () =>
      import(
        /* webpackChunkName: "signatureConfig" */ '../views/signatureConfig/SignatureConfig.vue'
      ),
    meta: {
      tabbable: true,
      tableKeys: [],
      filterKeys: [],
      formKeys: [],
      routePermissions: ['signatureUser'],
    },
  },
];
